import React, { useState } from "react";
import { Modal, Input } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { removeDomain } from "../../store/actions/domainActions";
import {
  LockTwoTone,
  DeleteTwoTone,
  LockOpenTwoTone,
} from "@material-ui/icons";
import LCIconButton from "../styles/LCIconButton";
import LCButton from "../styles/LCButton";

const RemoveDomain = ({ domain, archive = false }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const dispatch = useDispatch();
  const [confirmCheck, setConfirmCheck] = useState("");
  const isLoading = useSelector((state) => state.config.disableButton);
  const currentDomain = useSelector((state) => state.domains.currentDomain);

  const showModal = () => {
    setConfirmCheck("");
    setIsModalVisible(true);
  };

  const handleOk = () => {
    dispatch(
      removeDomain(domain._id, currentDomain, setIsModalVisible, archive)
    );
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const iconStyle = { fontSize: "26px", color: "#002f53" };

  const archiveOrUnarchive = domain.archive ? (
    <LockTwoTone style={iconStyle} />
  ) : (
    <LockOpenTwoTone style={iconStyle} />
  );

  return (
    <>
      <LCIconButton
        type={archive ? "primary" : "secondary"}
        as="button"
        onClick={showModal}
      >
        {archive ? archiveOrUnarchive : <DeleteTwoTone />}
      </LCIconButton>
      <Modal
        title={`${archive ? "Archive/UnArchive" : "Remove"} ${domain.name}`}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Confirm"
        keyboard={false}
        maskClosable={false}
        okButtonProps={{
          disabled: confirmCheck !== domain.name,
          loading: isLoading,
          type: "danger",
        }}
        footer={[
          <LCButton type="primary" as="button" onClick={handleCancel} addMargin>
            Cancel
          </LCButton>,
          <LCButton
            type="secondary"
            as="button"
            onClick={handleOk}
            addMargin
            disabled={confirmCheck !== domain.name}
          >
            Confirm
          </LCButton>,
        ]}
      >
        <p>
          Please type "{domain.name}" to confirm
          {archive ? "!" : " once confirm all related data will be removed."}
        </p>
        <Input
          placeholder={`please type ${domain.name}`}
          value={confirmCheck}
          onChange={(e) => setConfirmCheck(e.target.value)}
        />
      </Modal>
    </>
  );
};

export default RemoveDomain;
